import makeHead from 'components/Table/Head' 

const AssessmentsHead = makeHead([
  { id: 'title', align: 'left', disablePadding: false},
  { id: 'start', align: 'left', disablePadding: true},
  { id: 'finish', align: 'left', disablePadding: true},
  { id: 'type', align: 'left', disablePadding: true},
  { id: 'duration', align: 'left', disablePadding: true}
],({styles}) => ({...styles}))

export {AssessmentsHead as default}

